import type { IconData } from '@stacksjs/iconify-core'

export const tabletCapsuleFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M42.443 5.556c-2.787-2.786-6.17-4.128-9.625-4.053c-3.437.075-6.823 1.547-9.668 4.165c-2.379 2.187-5.317 4.994-8.902 8.58c-3.585 3.585-6.393 6.523-8.58 8.902c-2.618 2.845-4.09 6.23-4.165 9.668c-.075 3.454 1.267 6.838 4.053 9.625s6.17 4.128 9.625 4.053c3.438-.074 6.823-1.547 9.669-4.165c2.378-2.187 5.316-4.994 8.901-8.58c3.586-3.585 6.393-6.523 8.58-8.901c2.618-2.846 4.09-6.231 4.165-9.669c.075-3.454-1.267-6.838-4.053-9.625\"/><path fill=\"#2859c5\" d=\"M33.752 33.75c3.585-3.584 6.391-6.522 8.579-8.9c2.617-2.846 4.09-6.231 4.165-9.669c.075-3.454-1.267-6.838-4.054-9.625s-6.17-4.128-9.624-4.053c-3.438.075-6.823 1.547-9.67 4.165c-2.377 2.187-5.315 4.994-8.9 8.579z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default tabletCapsuleFlat
